var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmailShare = function SvgEmailShare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 14,
    viewBox: "0 0 16 14",
    width: 16,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m241 25.0045333v7.7288c-.000882.88329-.71671 1.599118-1.6 1.6h-12.8c-.88329-.000882-1.599118-.71671-1.6-1.6v-7.7288l7.484267 4.1288c.320976.1768868.710223.1768868 1.0312 0zm-1.6-4.0045333c.88329.000882 1.599118.71671 1.6 1.6v1.3333333c0 .0971694-.052783.1866672-.137867.2336l-7.733333 4.2666667c-.080173.0442239-.177427.0442239-.2576 0l-7.733333-4.2666667c-.085084-.0469328-.137867-.1364306-.137867-.2336v-1.3333333c.000882-.88329.71671-1.599118 1.6-1.6z",
    fill: "#d44638",
    transform: "translate(-225 -21)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmailShare, _extends({
    svgRef: ref
  }, props));
});
export default "https://static.im-cdn.com/mjc/storefront/Cipher/static/media/EmailShare.b4fe1959.svg";
export { ForwardRef as ReactComponent };